import Swal from "sweetalert2";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

export default function SweetAlertService() {
  const axiosPrivate = useAxiosPrivate();

  const submitConfirmSwal = async (props = {}) => {
    const {
      title,
      text,
      confirmButtonText,
      denyButtonText,
      cancelButtonText,
      onConfirm,
    } = props;

    const result = await Swal.fire({
      title: title || "Do you want to save the changes?",
      text: text || "",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: confirmButtonText || "Save",
      denyButtonText: denyButtonText || "Don't save",
      cancelButtonText: cancelButtonText || "Cancel",
    });

    if (result.isConfirmed) {
      if (typeof onConfirm === "function") {
        await onConfirm();
      }
      return true;
    }

    if (result.isDenied) {
      return false;
    }

    return false;
  };

  const deleteSwal = (props) => {
    const {
      id,
      url,
      beforeTitle,
      beforeText,
      confirmButtonText,
      cancelButtonText,
      afterTitle,
      afterText,
      refreshList,
    } = props;
    Swal.fire({
      title: beforeTitle || "Are you sure?",
      text: beforeText || "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#950404",
      confirmButtonText: confirmButtonText || "Yes, delete it!",
      cancelButtonText: cancelButtonText || "No, cancel!",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosPrivate.post(
            url,
            JSON.stringify({ id }),
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          if (response?.data?.status === "success") {
            Swal.fire(
              afterTitle || "Deleted!",
              response?.data?.message ||
                afterText ||
                "Your file has been deleted.",
              "success",
            );
            refreshList();
          } else {
            console.log(response);
            Swal.fire(response?.data?.message, "", "error");
          }
        } catch (err) {
          console.log(err?.response);
          Swal.fire(err?.response?.statusText, "", "error");
        }
      }
    });
  };

  return { deleteSwal, submitConfirmSwal };
}
